import { Select } from 'antd';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { ISelectOption } from 'components/common/Select/types';

export const bankDetailsSelectClassName =
  'w-full !h-10 [&_.ant-select-selector]:!flex [&_.ant-select-selector]:!h-full [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!rounded-lg [&_.ant-select-selector]:!border-gray-200 [&_.ant-select-selector]:!px-3 [&_.ant-select-selector]:!text-sm [&_.ant-select-selector]:!font-normal [&_.ant-select-selector]:!text-black [&:not(.ant-select-disabled)_.ant-select-selector]:hover:!border-gray-300 [&.ant-select-disabled]:!opacity-100 [&.ant-select-disabled_.ant-select-selector]:!bg-gray-100 [&.ant-select-disabled_.ant-select-selector]:!text-black [&_.ant-select-selection-item]:!text-black [&_.ant-select-selection-placeholder]:!text-black [&>.ant-select-arrow]:!inset-y-0 [&>.ant-select-arrow]:!right-3 [&>.ant-select-arrow]:!left-auto [&>.ant-select-arrow]:!mt-0 [&>.ant-select-arrow]:!flex [&>.ant-select-arrow]:!h-auto [&>.ant-select-arrow]:!items-center [&>.ant-select-arrow]:!justify-center [&>.ant-select-arrow]:!leading-none [&:not(.ant-select-disabled)>.ant-select-arrow]:!text-black';

export function getBankDetailsSelectProps(disabled = false) {
  return {
    className: bankDetailsSelectClassName,
    suffixIcon: disabled ? null : undefined,
  };
}

interface BankDetailsSelectFieldProps {
  name: string;
  placeholder: string;
  options: ISelectOption[];
  rules?: RegisterOptions;
  disabled?: boolean;
}

export function BankDetailsSelectField({
  name,
  placeholder,
  options,
  rules,
  disabled = false,
}: BankDetailsSelectFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={disabled ? undefined : rules}
      render={({ field, fieldState }) => (
        <div>
          <Select
            placeholder={placeholder}
            disabled={disabled}
            status={fieldState.error ? 'error' : undefined}
            {...getBankDetailsSelectProps(disabled)}
            options={options.map(option => ({ label: option.label, value: option.value }))}
            value={field.value || undefined}
            onChange={value => field.onChange(value)}
            onBlur={field.onBlur}
          />
          {fieldState.error?.message ? (
            <p className='mb-0 mt-1 text-sm text-red-500'>{fieldState.error.message}</p>
          ) : null}
        </div>
      )}
    />
  );
}
